import TermsConditions from "../components/legal/TermsConditions";


export default function TermsConditionsView(){
    return(
        <TermsConditions/>
    )
}